import { render, staticRenderFns } from "./course-home.vue?vue&type=template&id=01ba22cc&scoped=true&"
import script from "./course-home.vue?vue&type=script&lang=js&"
export * from "./course-home.vue?vue&type=script&lang=js&"
import style0 from "./course-home.vue?vue&type=style&index=0&id=01ba22cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ba22cc",
  null
  
)

export default component.exports